import {useSelector, useStore} from "@/components/resume/redux/hooks";
import getBaeInfoVisibleByField from "@/common/config/getBaeInfoVisibleByField";
import getFieldVisible from "@/common/config/getFieldVisible";

export default (id, field_name) => {
    return useSelector(state => getFieldVisible(state.resumeData, id, field_name));
}
